const ALLOWED_TAGS = [
    "P", "BR", "HR",
    "STRONG", "B", "EM", "I", "U", "S", "STRIKE", "DEL",
    "H1", "H2", "H3", "H4", "H5", "H6",
    "UL", "OL", "LI",
    "BLOCKQUOTE", "CODE", "PRE",
    "A", "SPAN",
];

const ALLOWED_ATTRIBUTES = {
    A: ["href", "title"],
};

const SAFE_PROTOCOLS = ["http:", "https:", "mailto:", "tel:"];

const isSafeHref = (value) => {
    const href = String(value || "").trim();

    if (href === "") {
        return false;
    }

    if (href.charAt(0) === "#" || href.charAt(0) === "/") {
        return true;
    }

    try {
        return SAFE_PROTOCOLS.indexOf(new URL(href).protocol) !== -1;
    } catch (error) {
        return false;
    }
};

const unwrap = (node) => {
    const parent = node.parentNode;

    if (!parent) {
        return;
    }

    while (node.firstChild) {
        parent.insertBefore(node.firstChild, node);
    }

    parent.removeChild(node);
};

const clean = (node) => {
    const children = Array.prototype.slice.call(node.childNodes);

    children.forEach((child) => {
        if (child.nodeType === 3) {
            return;
        }

        if (child.nodeType !== 1) {
            if (child.parentNode) {
                child.parentNode.removeChild(child);
            }
            return;
        }

        const tag = child.tagName.toUpperCase();

        if (tag === "SCRIPT" || tag === "STYLE" || tag === "IFRAME" || tag === "OBJECT" || tag === "EMBED") {
            child.parentNode.removeChild(child);
            return;
        }

        clean(child);

        if (ALLOWED_TAGS.indexOf(tag) === -1) {
            unwrap(child);
            return;
        }

        const allowed = ALLOWED_ATTRIBUTES[tag] || [];

        Array.prototype.slice.call(child.attributes).forEach((attribute) => {
            if (allowed.indexOf(attribute.name.toLowerCase()) === -1) {
                child.removeAttribute(attribute.name);
            }
        });

        if (tag === "A") {
            if (isSafeHref(child.getAttribute("href"))) {
                child.setAttribute("rel", "noopener noreferrer nofollow");
                child.setAttribute("target", "_blank");
            } else {
                child.removeAttribute("href");
            }
        }
    });
};

export const sanitizeHtml = (html) => {
    const source = String(html || "").trim();

    if (source === "") {
        return "";
    }

    const parsed = new DOMParser().parseFromString(source, "text/html");

    clean(parsed.body);

    return parsed.body.innerHTML;
};

export const htmlToText = (html) => {
    const source = String(html || "").trim();

    if (source === "") {
        return "";
    }

    const parsed = new DOMParser().parseFromString(source, "text/html");

    return parsed.body.textContent || "";
};

export default sanitizeHtml;
